import { injectable } from 'inversify';
import { ViewStateService } from '../../state/reduxViewServices/view.service';
import {
  AddPlayerViewState,
  ViewStates,
} from '../../state/reduxViewServices/view.slice';
import { RootState, useAppSelector } from '../../state/hooks';

// TODO: break out and extend similar to queryParams and share slice. To speed up creation of view services.
@injectable()
export class AddPlayerViewService extends ViewStateService<AddPlayerViewState> {
  constructor() {
    super(ViewStates.addPlayer);
  }

  useHasPendingConneqtInfoSelector = () => {
    return useAppSelector(() => {
      const viewState = this.viewStateSelector();
      return !!viewState.playerIdToConneqt && !!viewState.emailToConneqtWith;
    });
  };

  dispatchPendingConneqtInfo = (
    playerIdToConneqt: string,
    emailToConneqtWith?: string,
  ) => {
    this.dispatchViewState({
      playerIdToConneqt,
      emailToConneqtWith,
    });
  };
}
